import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { MarktTab } from '@/components/laadplein/MarktTab';
import { CorridorsTab } from '@/components/laadplein/CorridorsTab';
import { ConcurrentieTab } from '@/components/laadplein/ConcurrentieTab';
import { LocatiesTab } from '@/components/laadplein/LocatiesTab';
import { DemandTab } from '@/components/laadplein/DemandTab';
import { RoadmapTab } from '@/components/laadplein/RoadmapTab';
import { useLaadpleinData } from '@/hooks/useLaadpleinData';

export default function LaadpleinIntelligence() {
  const [activeTab, setActiveTab] = useState('markt');
  const { data, addLocatie, removeLocatie, isLoading, isAdding } = useLaadpleinData();

  return (
    <div className="min-h-screen">
      <div className="bg-emerald-900 text-white px-4 py-3 rounded-t-lg">
        <div className="text-xs text-emerald-400 font-medium tracking-wide">GREENVISION ENERGY</div>
        <div className="text-lg font-semibold">Laadplein Intelligence</div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="w-full justify-start rounded-none border-b bg-emerald-900 px-4 pb-0 overflow-x-auto">
          <TabsTrigger value="markt" className="text-emerald-200 data-[state=active]:bg-white data-[state=active]:text-emerald-900 rounded-b-none">
            Marktoverzicht
          </TabsTrigger>
          <TabsTrigger value="corridors" className="text-emerald-200 data-[state=active]:bg-white data-[state=active]:text-emerald-900 rounded-b-none">
            Corridors
          </TabsTrigger>
          <TabsTrigger value="concurrentie" className="text-emerald-200 data-[state=active]:bg-white data-[state=active]:text-emerald-900 rounded-b-none">
            Concurrentie
          </TabsTrigger>
          <TabsTrigger value="locaties" className="text-emerald-200 data-[state=active]:bg-white data-[state=active]:text-emerald-900 rounded-b-none">
            Locatiescorer
          </TabsTrigger>
          <TabsTrigger value="demand" className="text-emerald-200 data-[state=active]:bg-white data-[state=active]:text-emerald-900 rounded-b-none">
            Demand Calculator
          </TabsTrigger>
          <TabsTrigger value="roadmap" className="text-emerald-200 data-[state=active]:bg-white data-[state=active]:text-emerald-900 rounded-b-none">
            Productie Roadmap
          </TabsTrigger>
        </TabsList>

        <div className="max-w-6xl mx-auto p-4">
          <TabsContent value="markt"><MarktTab /></TabsContent>
          <TabsContent value="corridors"><CorridorsTab /></TabsContent>
          <TabsContent value="concurrentie"><ConcurrentieTab /></TabsContent>
          <TabsContent value="locaties">
            <LocatiesTab locaties={data.locaties} onAdd={addLocatie} onRemove={removeLocatie} isLoading={isLoading} isAdding={isAdding} />
          </TabsContent>
          <TabsContent value="demand"><DemandTab /></TabsContent>
          <TabsContent value="roadmap"><RoadmapTab /></TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
